export default "__VITE_ASSET__4be99a56__"